import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TabsModule } from "ng2-bootstrap/components/tabs";
import { PaginationModule } from "ng2-bootstrap/components/pagination";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ApplicationComponent } from "./applications";
import { MessagesComponent } from "./messages";
import { TasksComponent } from "./tasks";
import { UserDetailsComponent } from "./userDetails";
import { WarningInfoComponent, AppInfoComponent, ViewRolesComponent } from "./applications";
import { AccountsComponent } from "./accounts";
import { AppAccessComponent, ApplicationAccessComponent, AssignGroupRolesComponent, AssignUserRolesComponent }
  from "./applicationAccess";
  import { ReportsComponent, ElearningComponent } from "./reports";
import { UserAccountInfoComponent, UserContactInfoComponent, UserLoginInfoComponent, UserOrganisationInfoComponent, SecretQuestionsComponent }
  from "./userDetails";
import { UserHomeService } from "./userHome.service";
import { USERHOMEROUTING } from "./userHome.route";
import { UserHomeComponent } from "./userHome.component";
import { EmailTemplatesComponent, EmailTemplateEditComponent } from "./emailTemplates";
import { SiteAdminComponent} from "./siteAdmin/siteAdmin.component";
import { UserForceSecretComponent } from "./userForceSecret.component";
import { ForceContactInfoUpdateComponent } from "./userDetails/forceContactInfoUpdate.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TabsModule,
    PaginationModule,
    NgbModule,
    USERHOMEROUTING
  ],
  declarations: [
    UserHomeComponent,
    UserForceSecretComponent,
    TasksComponent,
    ApplicationComponent,
    MessagesComponent,    
    AccountsComponent,
    UserDetailsComponent,
    ReportsComponent,
    EmailTemplatesComponent,
    EmailTemplateEditComponent,
    ElearningComponent,
    UserAccountInfoComponent,
    UserContactInfoComponent,
    UserLoginInfoComponent,
    UserOrganisationInfoComponent,
    SecretQuestionsComponent,
    AppInfoComponent,
    WarningInfoComponent,
    ViewRolesComponent,
    ApplicationAccessComponent,
    AssignGroupRolesComponent,
    AppAccessComponent,
    AssignUserRolesComponent,
    ForceContactInfoUpdateComponent,
    SiteAdminComponent
  ],
  providers: [UserHomeService]
})

export class UserHomeModule { }



// WEBPACK FOOTER //
// ./src/app/modules/userHome/userHome.module.ts